import React from 'react';

export const ArrowLeftSvg = props => 
    <svg x="0px" y="0px" viewBox="0 0 137.8 137.8">
        <path d="M68.9,0C30.9,0,0,30.9,0,68.9c0,38.1,30.9,68.9,68.9,68.9s68.9-30.9,68.9-68.9C137.8,30.9,107,0,68.9,0z
	 M117,74.4c-1.2,3.2-3.6,4.4-7,4.3c-20-0.1-40,0-60.1,0h-2.7c0.8,0.8,1.3,1.4,1.8,1.9c5.9,5.9,11.9,11.9,17.9,17.8
	c3,3,2.9,5.6,0,8.7c-4.5,4.9-7.1,5.6-12.4,0.1c-10.2-10.7-20.8-21-31.1-31.4c-0.9-1.1-1.8-2.3-2.5-3.6v-2.1c0.7-1.2,1.5-2.4,2.4-3.5
	c11-11.1,22-22.1,33.1-33.1c3.1-3.1,5.7-3,9,0c5.1,4.7,5,7.4,0.1,12.1c-5.5,5.2-10.8,10.8-16.2,16.2c-0.5,0.5-0.9,1-1.7,1.9h2.7
	c20,0,40,0,60.1,0c3.2,0,5.5,1,6.8,3.9V74.4z"/>
    </svg>